/**
 * Centralized Chat Service
 * This service manages the Tawktrik chat widget functionality across the entire website.
 */

let chatInitialized = false;

/**
 * Initialize the chat widget
 * This function will be called once when the app loads
 */
export const initializeChat = () => {
  if (chatInitialized) {
    return;
  }

  // Wait for Tawktrik script to load
  const checkInterval = setInterval(() => {
    if (window.cd360Api && window.cd360Api.liveChat) {
      console.log('Tawktrik chat widget loaded successfully');
      chatInitialized = true;
      clearInterval(checkInterval);
    }
  }, 100);

  // Stop checking after 10 seconds
  setTimeout(() => clearInterval(checkInterval), 10000);
};

/**
 * Open the chat widget
 * This function is called when any "Chat Now" or "Get Free Consultation" button is clicked
 */
export const openChat = () => {
  console.log('Opening Tawktrik chat widget...');
  
  // Check if Tawktrik API is available
  if (window.cd360Api && window.cd360Api.liveChat && window.cd360Api.liveChat.showWebWidget) {
    window.cd360Api.liveChat.showWebWidget();
    console.log('Chat widget opened successfully');
  } else {
    console.warn('Tawktrik chat widget not yet loaded. Please wait...');
    // Retry after a short delay
    setTimeout(() => {
      if (window.cd360Api && window.cd360Api.liveChat && window.cd360Api.liveChat.showWebWidget) {
        window.cd360Api.liveChat.showWebWidget();
      } else {
        console.error('Tawktrik chat widget failed to load');
      }
    }, 1000);
  }
};

/**
 * Close the chat widget
 */
export const closeChat = () => {
  console.log('Closing chat widget...');
  
  if (window.cd360Api && window.cd360Api.liveChat && window.cd360Api.liveChat.hideWebWidget) {
    window.cd360Api.liveChat.hideWebWidget();
  }
};

/**
 * Check if chat is available
 */
export const isChatAvailable = () => {
  return chatInitialized && window.cd360Api && window.cd360Api.liveChat;
};

